document.addEventListener('DOMContentLoaded', () => {

    const selector = document.querySelector('[data-ticket-selector]');

    if (!selector) {
        return;
    }

    const addButton = selector.querySelector('[data-add-tickets]');
    const totalElement = selector.querySelector('[data-ticket-total]');
    const countElement = selector.querySelector('[data-ticket-count]');


    /*
     * Format a price in pounds
     */
    function formatMoney(cents) {

        return new Intl.NumberFormat('en-GB', {
            style: 'currency',
            currency: 'GBP'
        }).format(cents / 100);

    }

    
    

    /*
 * Update a ticket when its variant changes
 */
function updateVariant(ticket) {

    const select = ticket.querySelector('[data-variant-select]');

    if (!select) {
        return;
    }

    const option = select.selectedOptions[0];

    const quantityInput = ticket.querySelector('[data-ticket-quantity]');
    const priceElement = ticket.querySelector('[data-ticket-price]');

    quantityInput.dataset.variantId = option.value;
    quantityInput.dataset.price = option.dataset.price;

    quantityInput.max = option.dataset.inventory;

    if (priceElement) {

        const price = parseInt(option.dataset.price, 10);

        priceElement.textContent =
            price > 0 ? formatMoney(price) : 'Free';

    }

    /*
     * Reduce quantity if it exceeds stock
     */
    let quantity = parseInt(quantityInput.value, 10) || 0;
    const max = parseInt(option.dataset.inventory, 10);

    if (!isNaN(max) && quantity > max) {
        quantityInput.value = max;
    }

    updateSummary();

}


    /*
     * Update the total and ticket count
     */
    function updateSummary() {

        let total = 0;
        let count = 0;

        selector.querySelectorAll('[data-ticket-quantity]').forEach(input => {

            const quantity = parseInt(input.value, 10) || 0;
            const price = parseInt(input.dataset.price, 10) || 0;

            total += quantity * price;
            count += quantity;

        });

        if (totalElement) {
            totalElement.textContent = formatMoney(total);
        }

        if (countElement) {
            countElement.textContent = count;
        }

        if (addButton) {
            addButton.disabled = count === 0;
        }

    }


    /*
     * Plus / minus buttons
     */
    selector.addEventListener('click', event => {

        const button = event.target.closest(
            '[data-quantity-minus], [data-quantity-plus]'
        );

        if (!button) {
            return;
        }

        const ticket = button.closest('[data-ticket]');

        if (!ticket) {
            return;
        }

        const input = ticket.querySelector('[data-ticket-quantity]');

        if (!input) {
            return;
        }

        let quantity = parseInt(input.value, 10) || 0;
        const maximum = parseInt(input.max, 10);

        /*
         * Increase quantity
         */
        if (button.hasAttribute('data-quantity-plus')) {

            if (isNaN(maximum) || quantity < maximum) {
                quantity++;
            }

        }


        /*
         * Decrease quantity
         */
        if (button.hasAttribute('data-quantity-minus')) {

            quantity = Math.max(0, quantity - 1);

        }


        input.value = quantity;

        updateSummary();

    });


    /*
     * Manual quantity input
     */
    selector.addEventListener('input', event => {

        if (!event.target.matches('[data-ticket-quantity]')) {
            return;
        }

        const input = event.target;

        let quantity = parseInt(input.value, 10) || 0;
        const maximum = parseInt(input.max, 10);

        /*
         * Never allow less than zero
         */
        quantity = Math.max(0, quantity);

        /*
         * Never allow more than available stock
         */
        if (!isNaN(maximum)) {
            quantity = Math.min(quantity, maximum);
        }

        input.value = quantity;

        updateSummary();

    });

    /*
 * Variant selector
 */
selector.addEventListener('change', event => {

    if (!event.target.matches('[data-variant-select]')) {
        return;
    }

    const ticket = event.target.closest('[data-ticket]');

    if (!ticket) {
        return;
    }

    updateVariant(ticket);

});


    /*
     * Add selected tickets to cart
     */
    if (addButton) {

        addButton.addEventListener('click', async () => {

            const items = [];

            selector.querySelectorAll('[data-ticket-quantity]').forEach(input => {

                let quantity = parseInt(input.value, 10) || 0;
                const variantId = input.dataset.variantId;
                const maximum = parseInt(input.max, 10);

                /*
                 * Apply the inventory limit one final time
                 * before sending to Shopify
                 */
                if (!isNaN(maximum)) {
                    quantity = Math.min(quantity, maximum);
                }

                if (quantity > 0 && variantId) {

                    items.push({
                        id: Number(variantId),
                        quantity: quantity
                    });

                }

            });


            if (!items.length) {
                return;
            }


            addButton.disabled = true;
            addButton.classList.add('loading');


            try {

                const response = await fetch(
                    window.Shopify.routes.root + 'cart/add.js',
                    {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                            'Accept': 'application/json'
                        },
                        body: JSON.stringify({
                            items: items
                        })
                    }
                );


                const data = await response.json();


                if (!response.ok) {
                    throw new Error(
                        data.description ||
                        'There was a problem adding your tickets.'
                    );
                }


                console.log('Tickets added:', data);


                /*
                 * Successfully added everything.
                 * Take the customer to the cart.
                 */
                window.location.href =
                    window.Shopify.routes.root + 'cart';


            } catch (error) {

                console.error('Ticket cart error:', error);

                alert(error.message);

            } finally {

                addButton.classList.remove('loading');

                updateSummary();

            }

        });

    }


    /*
     * Initialise the selector
     */
    /*
 * Initialise every variant selector
 */
selector.querySelectorAll('[data-ticket]').forEach(ticket => {
    updateVariant(ticket);
});

updateSummary();

});


document.querySelectorAll('[data-filter]').forEach(button => {

    button.addEventListener('click', () => {
        console.log('Clicked', button.dataset.filter);
        const filter = button.dataset.filter;

        document.querySelectorAll('[data-filter]').forEach(btn => {
            btn.classList.remove('active');
        });

        button.classList.add('active');

        document.querySelectorAll('[data-event-type]').forEach(event => {
             console.log(
                filter,
                event.dataset.eventType
            );

            if (
                filter === 'all' ||
                event.dataset.eventType === filter
            ) {
                event.style.display = '';
            } else {
                event.style.display = 'none';
            }

        });

    });

});